import { Component } from '@angular/core';

@Component({
  selector: 'app-readpqc24',
  templateUrl: './readpqc24.component.html',
  styleUrl: '../../../../../../../../styles-tabelle-orari.css'
})
export class Readpqc24Component {

}
